import routeTypes from '../constants/RouteTypes';

const routeTypeService = {
    isOptionsPage(routeType) {
        return routeType === routeTypes.ROUTE_TYPE_OPTIONS;
    },

    isMessagesPage(routeType) {
        return routeType === routeTypes.ROUTE_TYPE_MESSAGES;
    },

    isMenuPage(routeType) {
        return this.isOptionsPage(routeType) || this.isMessagesPage(routeType);
    },

    isTestOverviewPage(routeType) {
        return routeType === routeTypes.ROUTE_TYPE_TEST_OVERVIEW;
    },

    isRemoteOralPage(routeType) {
        return routeType === routeTypes.ROUTE_REMOTE_ORAL;
    },

    isTimeoutSafe(routeType) {
        const timeoutSafeRoutes = [
            routeTypes.ROUTE_TYPE_AUTO_SUBMIT_OFFLINE,
            routeTypes.ROUTE_TYPE_AUTO_SUBMIT,
            routeTypes.ROUTE_TYPE_DELIVERING,
            routeTypes.OPTIONS_ADD_EXTRA_TIME,
            routeTypes.OPTIONS_DELIVER_BANK,
            routeTypes.OPTIONS_EXIT_CHROME_APP,
            routeTypes.OPTIONS_EXIT_SEB,
            routeTypes.OPTIONS_FILE_DELIVERY_CHROME_APP,
            routeTypes.OPTIONS_FILE_DELIVERY,
            routeTypes.OPTIONS_WITHDRAW,
        ];

        return routeType && timeoutSafeRoutes.includes(routeType);
    },
};

export default routeTypeService;
